const data = [
    {
      id: 1,
      image: "https://img.icons8.com/ios-filled/64/2BAAEF/ms-excel.png",
      title: "EXCEL",
    },
    {
      id: 2,
      image: "https://img.icons8.com/wired/64/2BAAEF/power-bi.png",
      title: "POWERBI",
    },
    {
      id: 3,
      image: "https://img.icons8.com/ios-filled/64/2BAAEF/tableau-software.png",
      title: "TABLEAU",
    },
    {
      id: 4,
      image: "https://img.icons8.com/external-outline-juicy-fish/64/2BAAEF/external-sql-coding-and-development-outline-outline-juicy-fish.png",
      title: "SQL",
    },
    {
      id: 5,
      image: "https://img.icons8.com/external-tal-revivo-bold-tal-revivo/64/2BAAEF/external-mongodb-a-cross-platform-document-oriented-database-program-logo-bold-tal-revivo.png",
      title: "MONGODB",
    },
    {
      id: 6,
      image: "https://img.icons8.com/windows/64/2BAAEF/amazon-web-services.png",
      title: "AWS",
    },
    {
      id: 7,
      image: "https://img.icons8.com/fluency/64/000000/azure-1.png",
      title: "AZURE",
    },
    {
      id: 8,
      image: "https://img.icons8.com/external-vectorslab-glyph-vectorslab/64/2BAAEF/external-Html-seo-and-web-vectorslab-glyph-vectorslab.png",
      title: "HTML",
    },
    {
      id: 9,
      image: "https://img.icons8.com/ios-filled/64/2BAAEF/css3.png",
      title: "CSS",
    },
    
    
  ]
  export default data
  